import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAZWXYi42QbqN1OrO5vwiJSjPXXGhhvukM",
  authDomain: "ekamdhyas.firebaseapp.com",
  projectId: "ekamdhyas",
  storageBucket: "ekamdhyas.firebasestorage.app",
  messagingSenderId: "1070130193766",
  appId: "1:1070130193766:web:50ce114a0658c8812714a7",
  measurementId: "G-LFGKB9H89S"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);